export const CASH_BONUS = 'CashBonus';
export const FREE_MONEY_BONUS = 'FreeMoneyBonus';
export const DEPOSIT_BONUS = 'DepositBonus';
export const FREESPIN = 'FREESPIN';
export const FREEBET = 'FREEBET';
export const BONUS_PACKAGE = 'BONUS_PACKAGE';
export const LOTTERY = 'LOTTERY';
export const AFFORDABLE = 'AFFORDABLE';
export const BONUSES = 'BONUSES';
export const PROMOTIONS = 'PROMOTIONS';
export const OPT_IN = 'depositOptIn';
export const CAMPAIGN_ACCESS = 'CAMPAIGN_ACCESS';
export const SPORTSBOOK_BONUS = 'SPORTSBOOK_BONUS';
export const THUNDERBITE = 'thunderbite';
export const CAMPAIGN = 'campaign';
export const GOLDEN_CHIP = 'GOLDEN_CHIP';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

// this is the max delay you can pass in ms to setTimeout, which is around 24.8 days.
// any value higher than this will cause set timeout to overflow and execute immediately
export const MAX_TIMEOUT_DELAY = 2147483647;
